import React from 'react';

export default class MyBlock404 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='block-404'>
        <h1>Cette page n'est pas disponible</h1>
        <button onClick={this.props.history.goBack} className='btn btn-success'>
          Retour
        </button>
      </div>
    );
  }
}
